// 選択肢データの単一の出典 (single source of truth)
// ここを更新すると schema.ts の z.enum も追従する。

export interface SpeakerInfo {
  id: string;
  name: string;
  gender: 'female' | 'male';
  lang: string;
  desc: string;
}

export interface LanguageInfo {
  code: string;
  name: string;
}

// --- Provider ---
export const TTS_PROVIDERS = ['qwen3', 'bert-vits2', 'irodori'] as const;

export const TTS_PROVIDER_LABELS = {
  qwen3: 'Qwen3-TTS',
  'bert-vits2': 'Bert-VITS2',
  irodori: 'Irodori-TTS',
} as const;

// --- Mode / OutputFormat ---
export const TTS_MODES = ['synthesize', 'clone', 'design'] as const;
export const TTS_OUTPUT_FORMATS = ['wav', 'mp3'] as const;

// --- Qwen3 Speakers ---
export const QWEN3_SPEAKERS = [
  { id: 'ono_anna', name: 'Ono Anna', gender: 'female', lang: '日本語', desc: '明るく軽やかな声質の日本語女性' },
  { id: 'serena', name: 'Serena', gender: 'female', lang: '中国語', desc: '温かく穏やかな若い女性の声' },
  { id: 'vivian', name: 'Vivian', gender: 'female', lang: '中国語', desc: '明るくエッジの効いた若い女性の声' },
  { id: 'sohee', name: 'Sohee', gender: 'female', lang: '韓国語', desc: '感情豊かで温かい韓国語女性' },
  { id: 'aiden', name: 'Aiden', gender: 'male', lang: '英語', desc: '明るいアメリカ英語の男性、クリアな中音域' },
  { id: 'ryan', name: 'Ryan', gender: 'male', lang: '英語', desc: 'ダイナミックでリズミカルな英語男性' },
  { id: 'dylan', name: 'Dylan', gender: 'male', lang: '中国語', desc: '若々しい北京方言の男性、クリアで自然' },
  { id: 'eric', name: 'Eric', gender: 'male', lang: '中国語', desc: '四川方言の活発な男性、少しハスキー' },
  { id: 'uncle_fu', name: 'Uncle Fu', gender: 'male', lang: '中国語', desc: '落ち着いた低音の年配男性' },
] as const satisfies ReadonlyArray<SpeakerInfo>;

export const QWEN3_SPEAKER_IDS = QWEN3_SPEAKERS.map((s) => s.id) as unknown as readonly [string, ...string[]];

// 表示用 (現 ttsConstants.LANGUAGES と同形状)
export const QWEN3_LANGUAGES = [
  { code: 'Japanese', name: '日本語' },
  { code: 'Chinese', name: '中国語' },
  { code: 'English', name: '英語' },
  { code: 'Korean', name: '韓国語' },
  { code: 'German', name: 'ドイツ語' },
  { code: 'French', name: 'フランス語' },
  { code: 'Russian', name: 'ロシア語' },
  { code: 'Portuguese', name: 'ポルトガル語' },
  { code: 'Spanish', name: 'スペイン語' },
  { code: 'Italian', name: 'イタリア語' },
] as const satisfies ReadonlyArray<LanguageInfo>;

// enum用 (display配列から導出)
export const QWEN3_LANGUAGE_CODES = QWEN3_LANGUAGES.map((l) => l.code) as unknown as readonly [string, ...string[]];
